import React from 'react';
import Card from '../card/card';
import {
  Modal,
  Radio,
  Checkbox,
  Skeleton,
  LazyImage,
  Accordion,
  Typography,
  Input as GInput,
  Button as GButton,
  Select as GSelect,
} from '../baseElement';
import LeafletMap from '../map';
import GIcon from '../baseElement/icon';
import Alert from '../baseElement/alert';
import Price from '../baseElement/price';
import Stepper from '../baseElement/stepper';
import LoadingButton from '../baseElement/loadingButton';
import File from '../baseElement/file';
import Upload from '../baseElement/upload';
import Editor from '../baseElement/editor';
import { GLink } from '../router';
import ParseHTML from '../parseHTML';
import Spinner from '../baseElement/spinner';
import GAlert from '../GAlert';
import Counter from '../baseElement/counter';
import GTextarea from '../baseElement/textarea';
import HintModal from '../baseElement/hint';
import GuidnessModal from '../baseElement/guidnessModal';
import LoadingWrapper from '../baseElement/loadingWrapper';
import Tabs from '../baseElement/tab';
import GTab, { ScrollTab } from '../baseElement/gTab';
import Badge from '../baseElement/badge';
import { Toast } from '../baseElement/toast';
import { JSX } from 'react/jsx-runtime';

function Atom() {
  return <React.Fragment></React.Fragment>;
}

const Div = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;
Atom.Div = Div;

const Button = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLButtonElement> & React.ButtonHTMLAttributes<HTMLButtonElement>) => <button {...props} />;
Atom.Button = Button;

const Span = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLSpanElement> & React.HTMLAttributes<HTMLSpanElement>) => <span {...props} />;
Atom.Span = Span;

const H1 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h1 {...props}>{props.children}</h1>;
Atom.H1 = H1;

const H2 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h2 {...props}>{props.children}</h2>;
Atom.H2 = H2;

const H3 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h3 {...props}>{props.children}</h3>;
Atom.H3 = H3;

const H4 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h4 {...props}>{props.children}</h4>;
Atom.H4 = H4;

const H5 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h5 {...props}>{props.children}</h5>;
Atom.H5 = H5;

const H6 = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement>) => <h6 {...props}>{props.children}</h6>;
Atom.H6 = H6;

const Nav = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLElement> & React.HTMLAttributes<HTMLElement>) => <nav {...props} />;
Atom.Nav = Nav;

const Section = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLElement> & React.HTMLAttributes<HTMLElement>) => <section {...props} />;
Atom.Section = Section;

const Hr = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLHRElement> & React.HTMLAttributes<HTMLHRElement>) => <hr {...props} />;
Atom.Hr = Hr;

const Li = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLLIElement> & React.LiHTMLAttributes<HTMLLIElement>) => <li {...props} />;
Atom.Li = Li;

const Menu = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLElement> & React.MenuHTMLAttributes<HTMLElement>) => <menu {...props} />;
Atom.Menu = Menu;

const Ol = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLOListElement> & React.OlHTMLAttributes<HTMLOListElement>) => <ol {...props} />;
Atom.Ol = Ol;

const Ul = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLUListElement> & React.HTMLAttributes<HTMLUListElement>) => <ul {...props} />;
Atom.Ul = Ul;

const P = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLParagraphElement> & React.HTMLAttributes<HTMLParagraphElement>) => <p {...props} />;
Atom.P = P;

const A = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>) => <a {...props}>{props.children}</a>;
Atom.A = A;

const Abbr = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLElement> & React.HTMLAttributes<HTMLElement>) => <abbr {...props} />;
Atom.Abbr = Abbr;

const Br = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLBRElement> & React.HTMLAttributes<HTMLBRElement>) => <br {...props} />;
Atom.Br = Br;

const I = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLElement> & React.HTMLAttributes<HTMLElement>) => <i {...props} />;
Atom.I = I;

const Area = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLAreaElement> & React.AreaHTMLAttributes<HTMLAreaElement>) => <area {...props} alt={props.alt || ''} />;
Atom.Area = Area;

const Audio = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLAudioElement> & React.AudioHTMLAttributes<HTMLAudioElement>) => <audio {...props} />;
Atom.Audio = Audio;

const Img = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLImageElement> & React.ImgHTMLAttributes<HTMLImageElement>) => <img {...props} alt={props.alt || ''} />;
Atom.Img = Img;

const Map = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLMapElement> & React.MapHTMLAttributes<HTMLMapElement>) => <map {...props} />;
Atom.Map = Map;

const Video = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLVideoElement> & React.VideoHTMLAttributes<HTMLVideoElement>) => <video {...props} />;
Atom.Video = Video;

const Iframe = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLIFrameElement> & React.IframeHTMLAttributes<HTMLIFrameElement>) => <iframe {...props} title={props.title} />;
Atom.Iframe = Iframe;

const Svg = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => <svg {...props} />;
Atom.Svg = Svg;

const Canvas = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLCanvasElement> & React.CanvasHTMLAttributes<HTMLCanvasElement>) => <canvas {...props} />;
Atom.Svg = Canvas;

const Table = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableElement> & React.TableHTMLAttributes<HTMLTableElement>) => <table {...props} />;
Atom.Table = Table;

const Tbody = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableSectionElement> & React.HTMLAttributes<HTMLTableSectionElement>) => <tbody {...props} />;
Atom.Tbody = Tbody;

const Thead = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableSectionElement> & React.HTMLAttributes<HTMLTableSectionElement>) => <thead {...props} />;
Atom.Thead = Thead;

const Tfoot = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableSectionElement> & React.HTMLAttributes<HTMLTableSectionElement>) => <tfoot {...props} />;
Atom.Tfoot = Tfoot;

const Tr = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableRowElement> & React.HTMLAttributes<HTMLTableRowElement>) => <tr {...props} />;
Atom.Tr = Tr;

const Td = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableDataCellElement> & React.TdHTMLAttributes<HTMLTableDataCellElement>) => <td {...props} />;
Atom.Td = Td;

const Th = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableHeaderCellElement> & React.ThHTMLAttributes<HTMLTableHeaderCellElement>) => <th {...props} />;
Atom.Th = Th;

const Del = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLModElement> & React.DelHTMLAttributes<HTMLModElement>) => <del {...props} />;
Atom.Del = Del;

const Colgroup = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableColElement> & React.ColgroupHTMLAttributes<HTMLTableColElement>) => <colgroup {...props} />;
Atom.Colgroup = Colgroup;

const Fieldset = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLFieldSetElement> & React.FieldsetHTMLAttributes<HTMLFieldSetElement>) => <fieldset {...props} />;
Atom.Fieldset = Fieldset;

const Form = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLFormElement> & React.FormHTMLAttributes<HTMLFormElement>) => <form {...props} />;
Atom.Form = Form;

const Input = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLInputElement> & React.InputHTMLAttributes<HTMLInputElement>) => <input {...props} />;
Atom.Input = Input;

const Textarea = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTextAreaElement> & React.TextareaHTMLAttributes<HTMLTextAreaElement>) => <textarea {...props} />;
Atom.Textarea = Textarea;

const Label = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLLabelElement> & React.LabelHTMLAttributes<HTMLLabelElement>) => <label {...props} />;
Atom.Label = Label;

const Select = (props: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLSelectElement> & React.SelectHTMLAttributes<HTMLSelectElement>) => <select {...props} />;
Atom.Select = Select;

const SelectBox = (props) => <GSelect {...props} />;
Atom.SelectBox = SelectBox;
Atom.SelectBox.Option = SelectBox.Option;

const Strong = (props) => <strong {...props} />;
Atom.Strong = Strong;

const Option = (props) => <option {...props} />;
Atom.Option = Option;

const Center = (props) => <center {...props} />;
Atom.Center = Center;

const Content = (props) => <content {...props} />;
Atom.Content = Content;

const Sub = (props) => <sub {...props} />;
Atom.Sub = Sub;

const Icon = (props) => <GIcon {...props} />;
Atom.Icon = Icon;

Atom.Stepper = Stepper;
Atom.Stepper.Head = Stepper.Head;
Atom.Stepper.Body = Stepper.Body;
Atom.Stepper.Title = Stepper.Title;
Atom.Stepper.Content = Stepper.Content;

Atom.Modal = Modal;
Atom.Modal.Header = Modal.Header;
Atom.Modal.Title = Modal.Title;
Atom.Modal.Footer = Modal.Footer;

Atom.Radio = Radio;
Atom.Radio.Group = Radio.Group;
Atom.Checkbox = Checkbox;
Atom.Checkbox.Group = Checkbox.Group;
Atom.GButton = GButton;
Atom.GButton.Transparent = GButton.Transparent;
Atom.Typography = Typography;
Atom.Card = Card;
Atom.Skeleton = Skeleton;
Atom.GInput = GInput;
Atom.LazyImage = LazyImage;
Atom.Accordion = Accordion;
Atom.Alert = Alert;
Atom.LoadingButton = LoadingButton;
Atom.Price = Price;
Atom.LeafletMap = LeafletMap;
Atom.File = File;
Atom.Upload = Upload;
Atom.Editor = Editor;
Atom.GLink = GLink;
Atom.Parse = ParseHTML;
Atom.Spinner = Spinner;
Atom.GAlert = GAlert;
Atom.Counter = Counter;
Atom.GTextarea = GTextarea;
Atom.HintModal = HintModal;
Atom.GuidnessModal = GuidnessModal;
Atom.LoadingWrapper = LoadingWrapper;
Atom.Tabs = Tabs;
Atom.Tabs.Title = Tabs.Title;
Atom.Tabs.Content = Tabs.Content;
Atom.GTab = GTab;

Atom.Badge = Badge;
Atom.ScrollTab = ScrollTab;
Atom.Toast = Toast;

export default Atom;
